import {
  createVariableMap
} from "./chunk-UA42UUKW.mjs";
import {
  baseSemanticColor
} from "./chunk-R2H5WSR3.mjs";

// src/tokens/vars/semanticColorVars.ts
var semanticColorVars = createVariableMap(
  baseSemanticColor,
  "stack-semantic"
);

export {
  semanticColorVars
};
